import { convertMetersToUnit } from 'supporticon/utils/units'

const percentage = (a, b) => Math.floor(a / b * 100)

export default (badge, fundraisingPage, fitnessGoalUom) => {
  switch (badge.requirement) {
    case 'hasSetImage':
      return fundraisingPage.hasUpdatedImage
    case 'hasSelfDonated':
      return fundraisingPage.hasSelfDonated
    case 'hasSetStory':
      return fundraisingPage.hasUpdatedStory
    case 'raised':
      return fundraisingPage.raised >= badge.amount
    case 'raisedPercentage':
      return percentage(fundraisingPage.raised, fundraisingPage.target / 100) >= badge.amount
    case 'distance':
      return fundraisingPage.fitnessDistanceTotal >= badge.amount
    case 'distancePercentage':
      const totalInUnit = convertMetersToUnit(fundraisingPage.fitnessDistanceTotal, fitnessGoalUom)
      return percentage(totalInUnit, fundraisingPage.fitnessGoal) >= badge.amount
    default:
      return false
  }
}
